import {
  Camera,
  CheckCircle2,
  FileEdit,
  History,
  Mail,
  MessageSquare,
  Trash2,
} from "lucide-react";
import { Card, EmptyState, VTimeline, type VTimelineItem } from "@/components/ui";
import type { CaseFile, CaseHistoryEntry } from "@/domains/cases/api/types";

const ICONS: Record<CaseHistoryEntry["type"], React.ReactNode> = {
  created: <FileEdit className="size-3.5" aria-hidden />,
  assetAdded: <Camera className="size-3.5" aria-hidden />,
  assetRemoved: <Trash2 className="size-3.5" aria-hidden />,
  statusChanged: <History className="size-3.5" aria-hidden />,
  noteAdded: <MessageSquare className="size-3.5" aria-hidden />,
  mailSent: <Mail className="size-3.5" aria-hidden />,
  taskCompleted: <CheckCircle2 className="size-3.5" aria-hidden />,
};

const TONES: Record<CaseHistoryEntry["type"], VTimelineItem["tone"]> = {
  created: "primary",
  assetAdded: "success",
  assetRemoved: "error",
  statusChanged: "warning",
  noteAdded: "neutral",
  mailSent: "primary",
  taskCompleted: "success",
};

type CaseHistoryTabProps = {
  caseFile: CaseFile;
};

export function CaseHistoryTab({ caseFile }: CaseHistoryTabProps): React.JSX.Element {
  if (caseFile.history.length === 0) {
    return (
      <EmptyState
        title="Geen historiek"
        description="Acties op dit dossier worden hier vanaf nu bijgehouden."
      />
    );
  }

  const items: ReadonlyArray<VTimelineItem> = [...caseFile.history]
    .reverse()
    .map((h) => ({
      id: h.id,
      title: h.description,
      description: `door ${h.actorName}`,
      timestamp: h.timestamp.slice(0, 16).replace("T", " "),
      icon: ICONS[h.type],
      tone: TONES[h.type],
    }));

  return (
    <Card padding="lg">
      <VTimeline items={items} />
    </Card>
  );
}
